var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 21,
    viewBox: "0 0 55 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_43",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0.5H0V20.5H55V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2223 0.550171L10.9385 5.41233H4.13379L5.46532 0.550171H12.2223Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4356 7.31702L6.95574 20.5H0L3.61102 7.31702H10.4356Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0923 5.41233H14.7808L13.812 0.550171H20.9665L22.0923 5.41233Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 7.31702L25.4432 19.8784L24.9325 20.5H17.7869L17.6776 19.9496L15.1606 7.31702H22.5337L23.5801 11.8323L26.6644 7.31702H35.8669Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2871 0.60022L37.531 5.41225H28.248L31.7478 0.60022H41.2871Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8204 5.41228H39.5981L43.7716 0.5H50.8267L51.8204 5.41228Z",
    fill: "#E6BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 20.4498H47.8453L45.858 12.3295H34.0332L38.4054 7.31702H52.3169L53.3105 12.3295L54.9998 20.4498Z",
    fill: "#E6BEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvaLogo);
export default __webpack_public_path__ + "static/media/iva_logo.974045c9ab27cf9e8522379e47c03d04.svg";
export { ForwardRef as ReactComponent };